"use client";

import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { getJSON } from "@/utils/fetcher";

type StrikeApr = { apr: number; lastUpdated: number };
interface AprsResponse {
  bgt: Record<string, StrikeApr>;
  beradrome: Record<string, StrikeApr>;
  at: number;
}

export function useAprs() {
  return useQuery<AprsResponse>({
    queryKey: ["aprs", "all"],
    queryFn: () => getJSON<AprsResponse>("/api/earn/aprs"),
    // Align with route revalidate window; keep data fresh across tabs
    staleTime: 5 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}

export function useAprsByStrike(strike: bigint | string | undefined) {
  const str = typeof strike === "bigint" ? strike.toString() : strike;
  const { data, isLoading, error } = useAprs();

  const result = useMemo(() => {
    if (!str || !data) return null;
    const bgt = data.bgt[str]?.apr ?? 0;
    const beradrome = data.beradrome[str]?.apr ?? 0;
    return { bgt, beradrome, total: bgt + beradrome };
  }, [data, str]);

  return {
    data: result,
    isLoading,
    error,
  } as const;
}
